import { BasicStore } from '@bridebook/web/app-basic/lib/types';
import { TypedUseSelectorHook, useSelector as _useSelector } from 'react-redux';

/**
 * Typed useSelector
 */
export const useSelector: TypedUseSelectorHook<BasicStore> = _useSelector;

/**
 * Use for cached selectors that require a parameter.
 */
export function useCachedSelector<TParam, TResult>(
  selector: (state: BasicStore, param: TParam) => TResult,
  param: TParam,
): TResult;
export function useCachedSelector<TParam, TResult>(
  selector: (state: BasicStore, param: TParam) => TResult,
  param: TParam | undefined,
) {
  return useSelector((state) => (param !== undefined ? selector(state, param) : undefined));
}
